<template>
    <div>
        <div>
            <div class="flex justify-between">
                <label for="phone" class="block text-sm font-medium text-gray-700">Телефон</label>
            </div>
            <div class="mt-1">
                <input required v-model="fields.phone" type="text" name="phone" id="phone"
                       class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                       :class="{'border-red-500': getError('phone')}"
                       placeholder=""/>
                <span class="text-red-500 text-xs" v-if="getError('phone')">{{ getError('phone') }}</span>
            </div>
        </div>
        <div class="mt-2">
            <div class="flex justify-between">
                <label for="body" class="block text-sm font-medium text-gray-700">Сообщение</label>
            </div>
            <div class="mt-1">
                <textarea required v-model="fields.body" type="text" name="body" id="body"
                       class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                       :class="{'border-red-500': getError('body')}"
                       placeholder=""/>
                <span class="text-red-500 text-xs" v-if="getError('body')">{{ getError('body') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";

export default {
    props: {
        destinationId: {
            required: true
        },
        errors: {
            default: []
        }
    },

    computed: {
        ...mapState(qrCodeFormStore, ['code']),
        fields: {
            get() {
                return this.code.destinations[this.destinationId].data
            },
            set(val) {
                this.updateDestinationData(this.destinationId, val)
            }
        }
    },

    methods: {
        ...mapActions(qrCodeFormStore, ['updateDestinationData']),
        getError(field) {
            return this.errors[field]
        }
    }
}
</script>